module.exports = __webpack_public_path__ + "img/thumb_02.48eb3847.jpg";